<template>
    <div class="container-fluid">
        <h4 class="mb-2">Downloadable forms</h4>
        <b-row>
            <b-col class="col-xl-3 col-lg-3 col-md-4 col-12" v-for="(file,index ) in gettFormDownloadAllActive" :key="index">
            <appFileDownloadWD
            :fileId="file.id"
            :formTitle="file.form_title"
            :provider="file.provider"
            :other1="file.other1"
            :other2="file.other2"
            :fileUrl="file.url"
            class="iq-card-block iq-card-stretch iq-card-height"></appFileDownloadWD>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { findash } from '../../config/pluginInit'
import { mapGetters, mapActions } from 'vuex';
import appFileDownloadWD from '../../components/wd/FileDownloadWD.vue';

export default {
  name: 'Forms',
  components: { 
    appFileDownloadWD,
   },
  mounted () {
    findash.index()
  },
  data () {
    return {
  
    }
  },
  computed:{
      ...mapGetters([
        'gettFormDownloadAllActive',
        ]),
  },
  methods:{
    ...mapActions([
       'fetchFormDownloadAllActive',
    ]),
  },
  created(){
      this.fetchFormDownloadAllActive();
  }
   
}
</script>
